module.exports = __webpack_public_path__ + "static/media/marina.5f0232bf.svg";